module.exports = __webpack_public_path__ + "static/home-5-5-62297bde448eb5750afb4b758f9f910f.png";